import { render, staticRenderFns } from "./OfficeInvoiceStatements.vue?vue&type=template&id=e8d1c37a"
import script from "./OfficeInvoiceStatements.vue?vue&type=script&lang=js"
export * from "./OfficeInvoiceStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports